/**
 * EmptyState — återanvändbar tom-vy för listor.
 *
 * Används på Objekt/Moment/Anställda/Rapporter när det inte finns någon
 * data ännu, så att nya kunder får en tydlig CTA istället för en tom sida.
 */
export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  testId = "empty-state",
}) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center justify-center text-center py-16 px-6"
    >
      {Icon && (
        <div className="w-16 h-16 rounded-2xl bg-[var(--brand-forest)]/10 text-[var(--brand-forest)] flex items-center justify-center mb-5">
          <Icon size={32} weight="duotone" />
        </div>
      )}
      <h3 className="font-heading text-2xl tracking-tight">{title}</h3>
      {description && (
        <p className="text-sm text-text-muted mt-2 max-w-md">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
